import cssVar from "polished/lib/helpers/cssVar";
import { CSSProperties, MutableRefObject } from "react";

export const showIf = (condition: boolean): CSSProperties => condition ? {} : { display: 'none' };
export const hideIf = (condition: boolean): CSSProperties => showIf(!condition);

export const cssVarStr = (cssVariable: string): string => cssVar(cssVariable) as string;
export const cssVarNum = (cssVariable: string): number => cssVar(cssVariable) as number;

// Copy contents of specified text element to clipboard. Return true if successful
export function copyToClipboard(elementRef: string | MutableRefObject<HTMLTextAreaElement> | MutableRefObject<HTMLInputElement>): boolean {
    if (!elementRef) {
        return false;
    }

    if (typeof elementRef !== "string" && !elementRef.current) {
        return false;
    }

    if (typeof elementRef === "string") {
        const el = document.querySelector(elementRef);
        if ((el as HTMLTextAreaElement)?.select) {
            (el as HTMLTextAreaElement).select();
            document.execCommand('copy');
            return true;
        }
    } else {
        elementRef.current.select();
        document.execCommand('copy');
        return true;
    }
    return false;
}
